import IsLoading from "components/common/IsLoading";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import Spinners from "components/common/Spinners";
import { isExpired } from "components/common/Utils";
import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerWalletTransactions } from "store/actions/customerSlice";
import primaryRiyal from "assets/images/icons/primaryRiyal.svg";
import riyalRed from "assets/images/icons/riyalRed.svg";

const Wallet = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    loading1,
    perPage,
    totalCount1,
    totalPages1,
    currentPage1,
    customerWalletTransactions,
  } = useSelector((state) => state.Customers);

  const [activeTab, setActiveTab] = useState("all");

  useEffect(() => {
    getAllData();
  }, [activeTab]);

  const getAllData = (page) => {
    const payload = {
      id,
      perPage,
      pageNo: page || currentPage1 || 1,
      source: activeTab, // "transfer", "booking", "cashback", "refund", "bonus", "referral", "other"
      type: "all", // "credit", "debit"
      orderBy: -1,
    };
    dispatch(getCustomerWalletTransactions(payload));
  };

  const walletTypes = [
    { label: "All Transactions", value: "all" },
    { label: "Booked", value: "booking" },
    { label: "Cashback", value: "cashback" },
    { label: "Refunds", value: "refund" },
    { label: "Bonus", value: "bonus" },
    { label: "Referrals", value: "referral" },
  ];

  return (
    <div className="common_card_inner">
      <h2 className="fs_20">{t("Wallet")}</h2>
      <div className="tabs_btn mt-3">
        {walletTypes?.map((item) => (
          <button
            className={`${item?.value === activeTab ? "active" : ""}`}
            onClick={() => setActiveTab(item?.value)}
          >
            {item?.label}
          </button>
        ))}
      </div>
      <div className="transaction_history">
        {loading1 ? (
          <IsLoading />
        ) : customerWalletTransactions?.length === 0 ? (
          <NoDataFound />
        ) : (
          customerWalletTransactions?.map((item) => (
            <div className="single_item g_between" key={item?._id}>
              <div className="d-flex gap-4">
                {item?.type === "credit" && !isExpired(item?.expiresAt) ? (
                  <ChevronUp size={24} className="text_primary" />
                ) : (
                  <ChevronDown size={24} className="text_danger" />
                )}
                <div>
                  <h2 className="fs_14 text-capitalize">{item?.source}</h2>
                  <h2 className="fs_12 text_gray">{item?.createdAt}</h2>
                  <h2 className="fs_12 text_gray">
                    {isExpired(item?.expiresAt)
                    ? t("Expired")
                    : `${t("Expires in")} ${item?.expiresAt}`}
                  </h2>
                </div>
              </div>
              <h2
                className={`fs_14 px-3 ${
                  item?.type === "credit" && !isExpired(item?.expiresAt)
                    ? "text_primary"
                    : "text_danger"
                } `}
              >
                {item?.type === "debit" && "-"}
                <img
                  src={item?.type === "debit" ? riyalRed :  item?.type === "credit" && isExpired(item?.expiresAt) ? riyalRed : primaryRiyal}
                  width={13}
                  height={13}
                  alt="riyal"
                  className="me-1"
                />
                {item?.amount}{" "}
              </h2>
            </div>
          ))
        )}
      </div>
      {!loading1 && (
        <Paginations
          currentPage={currentPage1}
          totalPages={totalPages1}
          onPageChange={(page) => {
            getAllData(page);
          }}
          totalCount={totalCount1}
        />
      )}
    </div>
  );
};

export default Wallet;
